import withParams from "@src/components/widgets/HOC/withParams";
import React, { useCallback } from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetInnovationsParams } from "../interface";
import InnovationMargauxMotin from "design-system/src/Components/WidgetPart/LandingInnovation/InnovationMargauxMotin/InnovationMargauxMotin";
import useProductList, {
  InnovationProductAdditionalData,
} from "@src/components/widgets/hooks/useProductList";
import { useTranslation } from "@src/hooks/useTranslation";
import useCtaAction from "@src/components/widgets/hooks/useCtaAction";
import InnovationProductMargauxMotin, {
  IInnovationProductMargauxMotinProps,
} from "design-system/src/Components/WidgetPart/LandingInnovation/InnovationProduct/InnovationProductMargauxMotin/InnovationProductMargauxMotin";
import { usePushAppsModal } from "@src/lib/WidgetPushApp/WidgetPushApp";
import useCartModelChange from "@src/backbone/hooks/useCartModelChange";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";

const ProductItemRender = (
  props: IInnovationProductMargauxMotinProps<InnovationProductAdditionalData>
) => {
  const { product: flatProduct, onClick: defaultOnClick, ...rest } = props;
  const { id_product, actionType, link } = flatProduct;
  const { t } = useTranslation(["landing"]);
  const { generateClick, getSubmitLabel } = useCtaAction(id_product || "");
  const attachPushApps = flatProduct.attachPushApps;
  const { openModal, canShowPushApps } = usePushAppsModal();
  const { app } = useBackboneContext();
  const [cartData, cart] = useCartModelChange(["id_store"]);
  const productModel = app.getProduct(id_product);

  const onClick = generateClick(
    actionType && actionType === "open_link"
      ? { type: "open_link", link: link || "#" }
      : { type: actionType || "product_card" }
  );

  const handleClick = () => {
    if (attachPushApps && canShowPushApps()) {
      openModal();
    } else {
      onClick();
    }
  };

  return (
    <InnovationProductMargauxMotin
      {...rest}
      ctaLabel={getSubmitLabel(false, t("Je commande", "landing"))}
      product={{
        ...flatProduct,
        price: productModel?.getPriceVae(true, cart) || flatProduct.price,
        displayFromMention:
          !cartData.id_store || cartData.id_store === "0"
            ? t("À partir de", "Product")
            : undefined,
      }}
      onClick={handleClick}
    />
  );
};

const InnovationsMargauxMotin: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetInnovationsParams>((props) => {
    const { p, params } = props;
    const { t } = useTranslation(["UI"]);

    const { prepareMargauxMotinProductList } = useProductList(params);

    const renderProduct = useCallback(
      (data: IInnovationProductMargauxMotinProps, index: number) => {
        return (
          <ProductItemRender
            key={data.product.id_product + "-" + index}
            index={index}
            {...data}
          />
        );
      },
      []
    );
    return (
      <InnovationMargauxMotin<InnovationProductAdditionalData>
        title={p("title") + ""}
        highlightedTitle={p("subtitle")}
        coverImageId={p("ambiance_image")}
        products={prepareMargauxMotinProductList(3)}
        showLessLabel={t("Voir moins", "UI")}
        showMoreLabel={t("Voir plus", "UI")}
        renderProduct={renderProduct}
      />
    );
  });

export default InnovationsMargauxMotin;
